import { Component, OnInit } from '@angular/core';
import { Guid } from 'guid-typescript';
import { ModulPrAuspFilter } from 'src/app/data/ws/modul/modul-pr-ausp-filter.model';
import { FilterAuspRowComponent } from '../filter-ausp-row/filter-ausp-row.component';
import { MatTableDataSource } from '@angular/material/table';
import { ConstantsTableColsFilterWertAusp } from 'src/app/immutable/cols/constants-table-cols-filter-wert-ausp';
import { LocalService } from 'src/app/services/local.service';
import { UserGebaeudeFilter } from 'src/app/data/user/user-gebaeude-filter.model';
import { ModulAuspAnzahlAuspFilter } from 'src/app/data/ws/modul/modul-ausp-anzahl-ausp-filter.model';

@Component({
  selector: 'app-filter-ausp-tabelle',
  templateUrl: './filter-ausp-tabelle.component.html',
  styleUrls: ['./filter-ausp-tabelle.component.css'],
})
export class FilterAuspTabelleComponent implements OnInit {
  modulPrAuspFilter!: ModulPrAuspFilter;
  parentMainComponent!: FilterAuspRowComponent;
  id!: Guid;
  dataSource!: MatTableDataSource<ModulAuspAnzahlAuspFilter>;
  displayedColss!: string[];

  constructor(private localService: LocalService) {
   
  }

  ngOnInit(): void {}

  setVariablen(modulPrAuspFilter: ModulPrAuspFilter) { 
    this.modulPrAuspFilter = modulPrAuspFilter;

    this.displayedColss = ConstantsTableColsFilterWertAusp.getColumns();

    this.dataSource = new MatTableDataSource(
      modulPrAuspFilter.modulAuspAnzahlAuspFilterList
    );

    this.localService.modulAuspraegungPrFilter.subscribe((modulAuspraegungPrFilter) => {  
     // this.dataSource.data.forEach((entry) => {
      //  entry.anzahl = 0;
    //  });
    
      if (modulAuspraegungPrFilter?.modulPrAuspFilterList) {
        for (const filter of modulAuspraegungPrFilter.modulPrAuspFilterList) {
          if (filter.idModul === this.modulPrAuspFilter.idModul) {
            this.modulPrAuspFilter = filter;
            
            filter.modulAuspAnzahlAuspFilterList.forEach((auspraegung) => {
              let matchFound = false;
    
              this.dataSource.data.forEach((entry) => {
                if (entry.idMbMMa === auspraegung.idMbMMa) {
                  entry.anzahl = auspraegung.anzahl;
                  matchFound = true;
                }
              });
    
              if (matchFound) {
                return;
              }
            });
    
            break;
          }
        }
      }
    });
  }

  setCheckbox(idMbMMa: number) {
    let userGebaeudeFilter: UserGebaeudeFilter | null =
      this.localService.userGebaeudeFilter.value;
    let found = false;

    for (let i = 0; i < userGebaeudeFilter!.idModulList.length; i++) {
      if (
        userGebaeudeFilter!.idModulList[i] == this.modulPrAuspFilter.idModul &&
        userGebaeudeFilter!.idMbMMaList[i] == idMbMMa
      ) {
        userGebaeudeFilter!.idModulList.splice(i, 1);
        userGebaeudeFilter!.idMbMMaList.splice(i, 1);
        userGebaeudeFilter!.wertList.splice(i, 1);
 
        found = true;
        break;
      }
    }

    if (!found) {
      userGebaeudeFilter!.idModulList.push(this.modulPrAuspFilter.idModul);
      userGebaeudeFilter!.idMbMMaList.push(idMbMMa);
      userGebaeudeFilter!.wertList.push(null);
    }
 
    this.localService.userGebaeudeFilter.next(userGebaeudeFilter);
  }
}
